import API from '../API'
import { LegacyLoginData } from '../../models/Legacy/LegacyLoginData'

export default class LoginUserPassAPI extends API {
  public loginWithUsernameAndPassword(data: LegacyLoginData) {
    return this.post('api/legacy/auth', data)
  }
}
